import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { FileUpload } from "primereact/fileupload";
import { useForm } from "react-hook-form";

interface Iprops {
    singleData: any;
    open: boolean;
    hideDialog: () => void;
    toast: any;
    reloadData: () => void;
    hasPermission: (pageName: string, featureName?: string) => boolean;
}

export const NoteActivities = (props: Iprops) => {
    const [notes, setNotes] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [description, setDescription] = useState("");
    const [resumeFile, setResumeFile] = useState<File | null>(null);
    const [preview, setPreview] = useState<{ open: boolean; url: string; type: string }>({
        open: false,
        url: "",
        type: ""
    });
    const { handleSubmit, reset } = useForm<any>();

    const [imagePreviewUrl, setImagePreviewUrl] = useState<string | null>(null);
    const [previewVisible, setPreviewVisible] = useState(false);

    const handlePreviewImage = async (fileName: string) => {
        try {
            const token = JSON.parse(sessionStorage.getItem("auth") || "")?.token;

            const res = await fetch(`${baseUrl}Support/NoteFile/${fileName}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            if (!res.ok) throw new Error("Failed to fetch image");

            const blob = await res.blob();

            if (blob.size === 0) {
                setImagePreviewUrl(null);
                setPreviewVisible(false);
                return;
            }

            const objectUrl = URL.createObjectURL(blob);
            setImagePreviewUrl(objectUrl);
            setPreviewVisible(true);

        } catch (error) {
            console.error("Image preview error:", error);
            setImagePreviewUrl(null);
            setPreviewVisible(false);
        }
    };



    const loadNotes = async () => {
        setLoading(true);
        const response = await Fetch(`Support/getNotes?ticket_Id=${props.singleData.ticket_Number}`, "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setNotes(data.result || []);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (props.open) loadNotes();
    }, [props.open]);


    const onUpload = (event: any) => {
        const file = event.files[0];
        if (!file) return;

        const validTypes = ["image/png", "image/jpeg", "image/jpg"];
        if (!validTypes.includes(file.type)) {
            props.toast.current.show({ severity: "error", detail: "Please upload png/jpg image.", life: 3000, });
            event.options.clear();
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            props.toast.current.show({ severity: "error", detail: "Image must be less than 2 MB.", life: 3000, });
            event.options.clear();
            return;
        }
        setResumeFile(file);
        props.toast.current.show({ severity: "success", detail: "Screenshot added!", life: 2000, });
        event.options.clear();
    };


    const saveNote = async () => {
        if (!description || description.trim() === "") {
            props.toast.current.show({
                severity: "error",
                detail: "Please Enter a Activity",
                life: 3000,
            });
            return;
        }

        setSubmitting(true);

        try {
            const formData = new FormData();
            formData.append("Ticket_Id", props.singleData.ticket_Number.toString());
            formData.append("note_Text", description);

            if (resumeFile) formData.append("attachment", resumeFile);

            const response = await Fetch("Support/addNote", "POST", formData, null, null);

            if (response) {
                props.toast.current.show({
                    severity: "success",
                    detail: "Activity saved successfully!",
                    life: 3000,
                });

                reset();
                setDescription("");
                setResumeFile(null);
                props.reloadData();
                loadNotes();
            }
        } catch {
            props.toast.current.show({
                severity: "error",
                detail: "Failed to save note",
                life: 3000,
            });
        } finally {
            setSubmitting(false);
        }
    };

    const onSubmit = () => saveNote();

    const previewAttachment = (fileUrl: string) => {
        const lower = fileUrl.toLowerCase();
        if (lower.endsWith(".jpg") || lower.endsWith(".jpeg") || lower.endsWith(".png")) {
            setPreview({ open: true, url: fileUrl, type: "image" });
        }
        else if (lower.endsWith(".pdf")) {
            setPreview({ open: true, url: fileUrl, type: "pdf" });
        }
        else {
            window.open(fileUrl, "_blank");
        }
    };


    const onHide = () => {
        props.hideDialog();
        reset();
        setDescription("");
        setResumeFile(null);
        setNotes([])
    };

    const onDialogHide = () => {
        if (imagePreviewUrl) {
            URL.revokeObjectURL(imagePreviewUrl);
        }
        setPreviewVisible(false);
        setImagePreviewUrl(null);
    };


    return (
        <>
            <Dialog visible={props.open} style={{ width: "700px" }} header=" Activities" modal onHide={onHide}>
                <div className="flex flex-column" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <div className="p-fluid">
                        <div className="mb-3">
                            <label>Work Activities <span style={{ color: "red" }}>*</span></label>
                            <CKEditor editor={ClassicEditor} data={description} onChange={(event, editor) => setDescription(editor.getData())} />
                        </div>
                        <FileUpload chooseLabel="Upload Document" mode="basic" name="image" accept="image/*" customUpload uploadHandler={onUpload} auto />
                    </div>
                    <div className="flex justify-content-end mt-3">
                        <Button label="Post" loading={submitting} onClick={onSubmit} />
                    </div>
                    <div className="mt-4">
                        <h3 className="text-lg font-semibold mb-3">Comments:</h3>
                        {notes.map((note) => (
                            <div key={note.id} className="p-3 mb-3 border-round shadow-1 bg-blue-50 flex flex-column">
                                <div className="flex justify-content-between mb-2">
                                    <div className="flex align-items-center gap-2">
                                        <img
                                            src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
                                            alt="profile"
                                            style={{ width: "32px", height: "32px", borderRadius: "50%" }}
                                        />
                                        <strong>{note.created_By_Name}</strong>
                                    </div>

                                    <span>{note.created_At}</span>
                                </div>

                                <div
                                    className="mt-2"
                                    dangerouslySetInnerHTML={{ __html: note.note_Text }}
                                />

                                {note.file_Url && note.file_Url !== "" && (
                                    <div className="mt-3">
                                        <Button
                                            //  label="View Document"
                                            icon="pi pi-eye"
                                            className="p-button-success p-button-text p-0"
                                            onClick={() => handlePreviewImage(note.file_Url)}

                                        />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <Dialog header="Image Preview" visible={previewVisible} style={{ width: "50vw" }} modal onHide={onDialogHide}>
                    {imagePreviewUrl ? (
                        <img src={imagePreviewUrl} alt="Preview" style={{ width: "100%", borderRadius: "6px" }} />
                    ) : (
                        <p>No preview available</p>
                    )}
                </Dialog>
            </Dialog>

        </>
    );
};
